<template>
    <div>
        <div class="add-shared-device" v-if="showValid">
            <img :src="productImg" alt="" class="device-image">
            <p class="shared-by">{{ sharedBy }}</p>
            <ul class="authority-list">
                <li v-for="item in list" :key="item.name">{{item.title}}</li>
            </ul>
            <div class="buttons-content">
                <button class="add ui-button primary-button" @click="addShare">
                    <span v-if="!loading">{{ $t('share.popUp.add') }}</span>
                    <span v-else>
                        <infiniteLoading spinner="spiral" class="loading"></infiniteLoading>
                    </span>
                </button>
                <button class="cancel ui-button empty-button" @click="cancelShare">{{ $t('share.popUp.cancel') }}</button>
            </div>
        </div>
        <pop-up
            textAlign='left'
            :title="$t('share.popUp.failed')"
            :description="$t('share.popUp.failedReason')"
            :buttons="buttons"
            @cancel="cancel"
            v-if="showFailReason">
        </pop-up>
    </div>
</template>
<script>
import popUp from '@/components/popUp';
import { getShareInvitationById, joinShare } from '@/api/share';
import InfiniteLoading from 'vue-infinite-loading';
import { requestToApp } from '@/api/app';

export default {
    components: {
        popUp,
        InfiniteLoading
    },
    data () {

        return {
            showValid: false,
            loading: false,
            showFailReason: false,
            productImg: '',
            shareId: '',
            sharedBy: '',
            list: [],
            buttons: [
                {
                    click: 'cancel',
                    type: 'primary',
                    text: this.$t( 'share.popUp.confirm' )
                }
            ]
        };

    },
    async created () {

        this.shareId = this.$route.query.id;
        await getShareInvitationById( this.shareId ).then(( result ) => {

            this.list = result.channels[0].privileges;
            let user = result.owner.nickName;
            this.sharedBy = this.$t( 'share.addSharedDevice.sharedBy', { user });
            this.showValid = true;
            let displayType = result.channels[0].displayType;
            // 将设备型号传给app，拿回设备图片地址
            requestToApp( 'getProductImg', {modelname: displayType}, this.callback );
            requestToApp( 'modifyPageTitle', {title: this.$t( 'share.pageTitle.addSharedDevice' )});
        
        }, () => {

            this.$router.push( '/share/code-expried/' );
        
        });

    },
    methods: {
        callback ( url ) {

            this.productImg = url;
        
        },
        cancel () {

            this.showFailReason = false;
            requestToApp( 'cancelBackToApp' );

        },
        async addShare () {

            this.loading = true;
            await joinShare( this.shareId ).then(( res ) => {

                requestToApp( 'successBackToApp' );
            
            }, () => {

                this.showFailReason = true;
                this.loading = false;
            
            });

        },
        cancelShare () {

            requestToApp( 'cancelBackToApp' );

        }
    }
};
</script>
<style lang="less">
    .add-shared-device {
        padding: 0.6rem 0.6rem 3.36rem;
        width: 100%;
        box-sizing: border-box;
        .device-image {
            display: block;
            width: 3.2rem;
            height: 3.2rem;
            margin: auto;
        }
        .shared-by,
        .authority-list li {
            font-size: .26rem;
            font-weight: 400;
            color: #777;
            text-align: left;
            margin-top: .2rem;
        }
        .shared-by {
            margin-top: .6rem;
        }
        .authority-list {
            padding-left: .3rem;
            li {
                list-style-type: disc;
            }
        }
        .buttons-content {
            position: fixed;
            left: 0;
            bottom: 1rem;
            z-index: 5;
            width: 100%;
            text-align: center;
        }
        button {
            width: calc(100% - 1.2rem);
            font-size: .34rem;
            height: .88rem;
            line-height: .88rem;
            box-shadow: 0 0.02rem 0.12rem rgba(0, 157, 225, 0.4);
        }
        button.cancel {
            margin-top: .4rem;
        }
        .infinite-loading-container div {
            font-size: 0;
        }
        .loading-spiral {
            margin: 0.2rem auto !important;
            width: 0.4rem !important;
            height: 0.4rem !important;
            font-size: 0.4rem !important;
            line-height: unset !important;
            border-color: #fff !important;
            border-right-color: transparent !important;
        }
        .add.ui-button.primary-button,
        .add.ui-button.primary-button:hover,
        .cancel.ui-button.empty-button,
        .cancel.ui-button.empty-button:hover {
            position: static;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/share/addSharedDevice.vue